import { dateFormat } from "@ajayvikas/common-utils";
import { formatMoney, formatNumber } from "@ajayvikas/common-utils";
export const stringFormatter = (value) => value;
const dateFormatter = (value) => {
    if (!value)
        return "";
    return dateFormat(new Date(value), "mm/dd/yyyy");
};
export const getSummaryFormatter = (reportFormat, columnFormat) => {
    const { removeCents, showBlankForZero, negativeNumberFormat = "normal" } = reportFormat;
    const percentFormatter = (value) => {
        // if (!value) return removeCents ? "0%" : "0.0%";
        return formatMoney(value, {
            precision: removeCents ? 0 : 2,
            showBlankForZero: showBlankForZero,
            symbol: "%",
            format: {
                pos: "%v%s",
                zero: "%v%s",
                neg: negativeNumberFormat === "normal" ? "-%v%s" : negativeNumberFormat === "parentheses" ? "(%v%s)" : "%v%s-",
            }
        });
    };
    const numberFormatter = (value) => {
        // if (!value) return removeCents ? "0" : "0.00";
        const x = formatMoney(value, {
            precision: removeCents ? 0 : 2,
            showBlankForZero: showBlankForZero,
            symbol: "",
            format: {
                pos: "%s%v",
                zero: "%s%v",
                neg: negativeNumberFormat === "normal" ? "-%s%v" : negativeNumberFormat === "parentheses" ? "(%s%v)" : "%s%v-",
            }
        });
        return x;
    };
    const currencyFormatter = (value) => {
        // if (!value) return removeCents ? "0" : "0.00";
        const x = formatMoney(value, {
            precision: removeCents ? 0 : 2,
            showBlankForZero: showBlankForZero,
            symbol: "",
            format: {
                pos: "%s%v",
                zero: "%s%v",
                neg: negativeNumberFormat === "normal" ? "-%s%v" : negativeNumberFormat === "parentheses" ? "(%s%v)" : "%s%v-",
            }
        });
        return x;
    };
    const dateFormatter = (value) => {
        if (!value)
            return "";
        return dateFormat(new Date(value), "mm/dd/yyyy");
    };
    if (columnFormat === "Currency")
        return currencyFormatter;
    if (columnFormat === "Number")
        return numberFormatter;
    if (columnFormat === "Date")
        return dateFormatter;
    if (columnFormat === "Percent")
        return percentFormatter;
    return stringFormatter;
};
export const getDetailFormatter = (reportFormat, columnFormat) => {
    const { removeCents, showBlankForZero, negativeNumberFormat = "normal" } = reportFormat;
    const percentFormatter = (value) => {
        if (value === null || value === undefined)
            return "";
        if (!value)
            return "0.0%";
        return formatMoney(value, {
            precision: removeCents ? 0 : 2,
            showBlankForZero: showBlankForZero,
            symbol: "%",
            format: {
                pos: "%v%s",
                zero: "%v%s",
                neg: negativeNumberFormat === "normal" ? "-%v%s" : negativeNumberFormat === "parentheses" ? "(%v%s)" : "%v%s-",
            }
        });
    };
    const numberFormatter = (value) => {
        if (value === null || value === undefined)
            return "";
        if (!value)
            return "0.00";
        return formatMoney(value, {
            precision: removeCents ? 0 : 2,
            showBlankForZero: showBlankForZero,
            symbol: "",
            format: {
                pos: "%s%v",
                zero: "%s%v",
                neg: negativeNumberFormat === "normal" ? "-%s%v" : negativeNumberFormat === "parentheses" ? "(%s%v)" : "%s%v-",
            }
        });
    };
    const currencyFormatter = (value) => {
        if (value === null || value === undefined)
            return "";
        if (!value)
            return "0.00";
        return formatMoney(value, {
            precision: removeCents ? 0 : 2,
            showBlankForZero: showBlankForZero,
            symbol: "",
            format: {
                pos: "%s%v",
                zero: "%s%v",
                neg: negativeNumberFormat === "normal" ? "-%s%v" : negativeNumberFormat === "parentheses" ? "(%s%v)" : "%s%v-",
            }
        });
    };
    const exchangeRateFormatter = (value) => {
        if (value === null || value === undefined)
            return "";
        if (!value)
            return "0.00";
        return formatNumber(value, {
            precision: 7,
            minPrecision: 0
        });
    };
    if (columnFormat === "Currency")
        return currencyFormatter;
    if (columnFormat === "Number")
        return numberFormatter;
    if (columnFormat === "Date")
        return dateFormatter;
    if (columnFormat === "Percent")
        return percentFormatter;
    if (columnFormat === "ExchangeRate")
        return exchangeRateFormatter;
    return stringFormatter;
};
